/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 25.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";


class FormGroup extends React.Component {
    static propTypes = {
        /**
         * Label - node
         */
        label: PropTypes.node,
        helpText: PropTypes.node,
        inputId: PropTypes.string,
        validationStatus: PropTypes.oneOf(["success", "warning", "error", "", null]),
        /**
         * Validation object. If there exists attribute with same name as inputId, then this will be displayed as helpText
         * and validationStatus will be set to "error"
         */
        validation: PropTypes.object
    };

    static defaultProps = {
    };

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    renderHelpBlock() {
        let helpText = null;
        if (this.props.validation && this.props.validation[this.props.inputId])
            helpText = this.props.validation[this.props.inputId];
        if (this.props.helpText) helpText = this.props.helpText;
        if (!helpText) return null;
        return (
            <span id={this.props.inputId + "-help"} className="help-block">{helpText}</span>
        );
    }

    getGroupClass() {
        if (this.props.validationStatus) return "has-" + this.props.validationStatus;
        if (this.props.validation && this.props.validation[this.props.inputId]) return "has-error";
        return "";
    }

    renderNoLabel() {
        return (
            <div className={"form-group " + this.getGroupClass()}>
                <div className="col-sm-offset-2 col-sm-10">
                    {this.props.children}
                    {this.renderHelpBlock()}
                </div>
            </div>
        );
    }

    render() {
        if (this.props.label == null) return this.renderNoLabel();

        return (
            <div className={"form-group " + this.getGroupClass()}>
                <label htmlFor={this.props.inputId} className="col-sm-2 control-label">{this.props.label}</label>
                <div className="col-sm-10">
                    {this.props.children}
                    {this.renderHelpBlock()}
                </div>
            </div>
        );
    }
}

export default FormGroup;
